import { BillingPlan, PricingFeatureSubscription } from '@core/billing-types';

export const getProductCodename = (product: BillingPlan) => product.tier;

export const getProductCodenameFromSubscription = (subscription?: PricingFeatureSubscription) => {
  if (!subscription || ['inactive', 'trialing'].includes(subscription.status)) return;
  return subscription.tier;
};
